/*eslint-disable no-unused-vars*/
import React from 'react';
const latinize = require('latinize');
/*eslint-enable no-unused-vars*/

function stringSanitizer(string) {
  // Handle umlauts.
  latinize.characters['ü'] = 'ue'
  latinize.characters['ß'] = 'ss'
  latinize.characters['ä'] = 'ae'
  latinize.characters['ö'] = 'oe'
  latinize.characters['Ö'] = 'Oe'
  latinize.characters['Ü'] = 'Ue'
  latinize.characters['Ä'] = 'Ae'

  string = latinize(string)

  // Remove any symbols and special characters.
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9| -]+/g, '')
    .replace(/[ -]+/g, '-');
}

export default stringSanitizer;
